// @flow
import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, GoodSansB1, LINK, QueensH5 } from '@components/shared'
import { colors } from '../components/shared/colors'
import TopNav from '@components/TopNav'
import Footer from '@components/Footer'
import TopNavMobile from '@components/TopNavMobile'
import HeaderSection from '@components/write-for-us/Header'
import { getAudiobooksForWriteForUs, getTracksForWriteForUs } from '@components/write-for-us/series'
import DeepLinkCardsCarousel from '@components/Discover/DeepLinkCardsCarousel'
import styled from 'styled-components'
import { Col, config, Row } from 'react-awesome-styled-grid'
import { HeaderSeeAll } from '@components/shared/HeaderSeeAll'
import type { DeepLinkedCardsCarouselPropsType } from '../models/Discover'
import { TrackPreview } from '@components/write-for-us/TrackPreview'
import type { TrackPropsType } from '../models/Track'

type PropsType = {
  rec: DeepLinkedCardsCarouselPropsType,
  tracks: TrackPropsType[]
}

function WriteForUs (props: PropsType): React.Node {
  const [isAssetLoaded, setIsAssetLoaded] = React.useState <boolean>(false)
  return (
    <>
      <HtmlHead
        title={'Dipsea | Write for Dipsea'}
        description={
          'Dipsea is on the hunt for talented writers to expand our world of immersive audiobooks and audio dramas.'
        }
      />
      <GlobalStyle backgroundColor={colors.midnightBlue}/>
      <TopNav backgroundColor={colors.midnightBlue95} isAssetLoaded={true}/>
      <TopNavMobile
        backgroundColor={colors.midnightBlue95}
        isAssetLoaded={true}
      />
      <HeaderSection
        setLoadingComplete={(): void => setIsAssetLoaded(true)}
        takeMeThere={(id: string): void => {
        }}
        isMenuVisible={isAssetLoaded}
      />
      <Col>
        <SectionDivider>
          {props.rec && <DeepLinkCardsCarousel {...props.rec} />}
        </SectionDivider>
      </Col>
      <Col>
        <SectionDivider>
        <HeaderSeeAll title={'Step 2: Choose a style and template'} cta={null} description={null}/>
        <Row justify={'center'}>
          <Col sm={6} md={4} lg={4}>
            <SubHeader styles={{ 'margin-bottom': 28 }}>Style 1: Audio drama</SubHeader>
            <TrackPreview track={props.tracks[0]} popularity={0} slug="/audiobooks/all-american-series/"
                          title={props.tracks[0].title}
                          description={props.tracks[0].description.slice(0, 200).trim() + '...'}
                          imageUrl={props.tracks[0].images.img500}
            isSmall={true}/>
            <BodyText>Interested in writing a sample of an audio drama as your submission?
              Use this <LINK fontSize="18px" color={colors.tintOrange} href="https://docs.google.com/document/d/1TBA2856kWDzdb-H9XED4NzS0mVbxTWStyo0EEWQdfug/edit" target="_blank">audio drama script</LINK> as your style and
              content reference</BodyText>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <SubHeader styles={{ 'margin-bottom': 28 }}>Style 2: +You Character Experiences</SubHeader>
            <TrackPreview track={props.tracks[0]} popularity={0} slug="/audiobooks/all-american-series/"
                          title={props.tracks[1].title}
                          description={props.tracks[1].description.slice(0, 200).trim() + '...'}
                          imageUrl={props.tracks[1].images.img500}
                          isSmall={true}
            />
            <BodyText>Interested in writing a sample of +You script as your submission? Use this <LINK fontSize="18px"
                                                                                                color={colors.tintOrange}
            href="https://docs.google.com/document/d/12AzvMPrQ_I8D-rhp3EUAXXgY16lbOpG_JGyJuY2AHrc" target={'_blank'}>+You
              script</LINK> as your style and content reference</BodyText>
          </Col>
        </Row>
        </SectionDivider>
      </Col>
      <Col>
        <SectionDivider>
          <HeaderSeeAll title={'Step 3: Write a script '} cta={null} description={null}/>
          <BodyText>
            <ul>
              <li>Submissions should be around 1000-2000 words</li>
              <li>All sex should be consensual, pleasurable, and affirming</li>
              <li>Use the sample scripts as a style guide</li>
              <li>Don’t worry too much about sound design cues — our expert audio producers will add those during the
                production process
              </li>
            </ul>
          </BodyText>
        </SectionDivider>
      </Col>
        <Col>
          <HeaderSeeAll title={'Step 4: Submit your work'} cta={null} description={null}/>
            <Row justify={'center'}>
              <Col lg={6}>
                <iframe className="airtable-embed"
                        src="https://airtable.com/embed/appLP2gRGbVxyP2kk/pagsPJQDlGszbsV1o/form"
                        width="100%" height="1000"
                        style={{
                          background: colors.tintOrange,
                          border: '1px solid #ccc'
                        }}/>
              </Col>
            </Row>
        </Col>
      {isAssetLoaded && <Footer/>}
    </>
  )
}

const mapStateToProps = (state: AppStateType): any => {
  return {}
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WriteForUs))

export async function getStaticProps (): Promise<{ props: PropsType }> {
  const [rec, tracks] = await Promise.all([
    getAudiobooksForWriteForUs(),
    getTracksForWriteForUs()

  ])

  return {
    props: {
      rec,
      tracks
    }
  }
}

const SubHeader = styled.h4`
    ${QueensH5};
    margin-top: 24px;
    margin-bottom: 24px;
    font-size: 24px;
    @media (min-width: 768px) {
        font-size: 24px;
    }
    @media (min-width: 1024px) {
        font-size: 28px;
    }
    @media (min-width: 1440px) {
        font-size: 36px;
    }
`

const BodyText = styled.div`
    ${GoodSansB1};
`

const SectionDivider = styled.div`
    width: 100%;
    margin-top: 32px;
    margin-bottom: 32px;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
      margin-top: 48px;
      margin-bottom: 48px;
    `}
    ${(props: any): string => config(props).media.lg`
      margin-top: 56px;
      margin-bottom: 56px;
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
